import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { CommonUXModule } from '@shared/common-ux/common-ux.module';
import { TableUnfinishedReportsComponent } from './table-unfinished-reports/table-unfinished-reports.component';
import { TableTodoReportComponent } from './table-todo-report/table-todo-report.component';import { ToDoComponent } from './to-do.component';
import { TableTodoReportsComponent } from './table-todo-reports/table-todo-reports.component';
/** config angular i18n **/
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';

registerLocaleData(en);

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        CommonUXModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
    ],
    declarations: [
        TableUnfinishedReportsComponent,
        TableTodoReportComponent,
        TableTodoReportsComponent,
        ToDoComponent,
    ]
})
export class ToDoModule { }
